import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.QBooksVendorCreationConditionCell', {
    allowToCreateNewVendors: 'Allow to create new Vendors',
});
